var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "kanban-container p-3" },
    [
      _c(
        "b-row",
        {
          staticClass: "flex-nowrap overflow-auto",
          attrs: { "no-gutters": "" }
        },
        _vm._l(_vm.localColumns, function(column) {
          return _c(
            "b-col",
            { key: column.id, staticClass: "kanban-col" },
            [
              _c(
                "b-card",
                {
                  staticClass: "h-100 bg-light overflow-hidden",
                  attrs: { "no-body": "" }
                },
                [
                  _c(
                    "b-card-header",
                    {
                      class:
                        "border-" +
                        column.variant +
                        " font-weight-bold text-center"
                    },
                    [
                      _vm._v(
                        "\n          " + _vm._s(column.title) + "\n          "
                      ),
                      _c(
                        "b-badge",
                        { attrs: { pill: "", variant: column.variant } },
                        [_vm._v(_vm._s(column.items.length))]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-card-body",
                    { staticClass: "p-1 h-100 min-h-200" },
                    [
                      _c(
                        "draggable",
                        {
                          staticClass: "h-100",
                          attrs: {
                            group: _vm.groupName,
                            animation: "200",
                            "ghost-class": "ghost-card"
                          },
                          on: {
                            change: function(evt) {
                              return _vm.onItemMoved(evt, column.id)
                            }
                          },
                          model: {
                            value: column.items,
                            callback: function($$v) {
                              _vm.$set(column, "items", $$v)
                            },
                            expression: "column.items"
                          }
                        },
                        _vm._l(column.items, function(item) {
                          return _c(
                            "div",
                            { key: item.id, staticClass: "mb-2" },
                            [_vm._t("card", null, { item: item })],
                            2
                          )
                        }),
                        0
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0378ba28", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0378ba28","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/utilites/commonUi/Kanban.vue
// module id = null
// module chunks = 